import { useSelector } from 'react-redux';
import isSaleAllowed from 'src/utils/material/is-sale-allowed';
import { LATINA_LIST } from '../../../../../../constants/latina-country';
import { isFreeMaterial } from '../../../../../../utils/material/material-helper';
import SchoolAccount from '../../../../../../utils/school-account';

type UsePricesProps = { item: Material };
type UsePricesReturn = { isFree: boolean; isLatina: boolean; originalPrice: string | number };

const usePrices = ({ item }: UsePricesProps): UsePricesReturn => {
    const user = useSelector((state: RootState) => state.main.user);
    const { countryCode } = useSelector((state: RootState) => state.main.geotargeting);
    const isFree = isFreeMaterial(item);
    const isLatina = LATINA_LIST.includes(countryCode);
    const isBundleSale = !(SchoolAccount.isAdmin(user) || isLatina);
    const originalPrice = getOriginalPrice(isBundleSale, item, countryCode);

    return { isFree, isLatina, originalPrice };
};

const getOriginalPrice = (isBundleSale: boolean, item: Material, countryCode?: string): Price => {
    const { sale } = item;

    if (sale && isSaleAllowed(item, countryCode)) {
        return sale.original_price || '';
    }

    return isBundleSale ? item.bundleMaterialsPrice : '';
};

export default usePrices;
